import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    app: "",
    rail: _ctx.mini,
    permanent: "",
    "disable-route-watcher": true,
    clipped: true,
    color: "primary",
    theme: "dark"
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, {
        flat: "",
        class: "ma-0 pa-0",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.mini = !_ctx.mini), ["stop"]))
          }, {
            default: _withCtx(() => [
              (!_ctx.mini)
                ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-menu", -1)
                    ]))]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          (!_ctx.mini)
            ? (_openBlock(), _createBlock(_component_v_toolbar_title, {
                key: 0,
                class: "text-body-1"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("WUD", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_list, {
        nav: "",
        class: "pt-0 pb-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_fade_transition, {
            group: "",
            "hide-on-leave": "",
            mode: "in-out"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                to: "/",
                key: "home",
                class: "mb-0",
                "prepend-icon": "mdi-home"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("Home", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                to: "/containers",
                key: "containers",
                class: "mb-0",
                "prepend-icon": _ctx.containerIcon
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Containers", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["prepend-icon"]),
              _createVNode(_component_v_list_item, {
                key: "divider",
                class: "mb-0",
                dense: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_divider)
                ]),
                _: 1
              }),
              (!_ctx.mini)
                ? (_openBlock(), _createBlock(_component_v_list_group, {
                    key: "configuration",
                    color: "white"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, { "prepend-icon": "mdi-cogs" }), {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                              _createTextVNode("Configuration", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configurationItemsSorted, (configurationItem) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: configurationItem.to,
                          to: configurationItem.to,
                          class: "mb-0 pl-2",
                          "prepend-icon": configurationItem.icon
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "text-capitalize" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(configurationItem.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["to", "prepend-icon"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.configurationItemsSorted, (configurationItem) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: configurationItem.to,
                      to: configurationItem.to,
                      class: "mb-0",
                      "prepend-icon": configurationItem.icon
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "text-capitalize" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(configurationItem.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["to", "prepend-icon"]))
                  }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (!_ctx.mini)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, { class: "ml-2 mb-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_switch, {
                      "hide-details": "",
                      inset: "",
                      label: "Dark mode",
                      modelValue: _ctx.darkMode,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.darkMode) = $event)),
                        _ctx.toggleDarkMode
                      ]
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode("mdi-weather-night", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["rail"]))
}